import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter, Redirect, Switch } from 'react-router-dom'
import { unloadMessages } from '../../actions'
import MessagesList from './MessagesList'
import MessageDetail from './MessageDetail'
import withTopBar from '../../common/TopBar/withTopBar'

class Messages extends PureComponent {
  componentWillUnmount() {
    this.props.unloadMessages()
  }

  render() {
    return (
      <div>
        <Switch>
          <Route
            path="/messages/:type(inbox|outbox)"
            component={MessagesList}
          />
          <Route path="/messages/:id(\d+)" component={MessageDetail} />
          <Redirect from="/messages" to="/messages/inbox" />
        </Switch>
      </div>
    )
  }
}

export default withRouter(
  withTopBar({
    title: 'Messaggi',
    toolbar: 'MessagesToolbar',
  })(
    connect(undefined, {
      unloadMessages,
    })(Messages)
  )
)



// WEBPACK FOOTER //
// ./src/pages/Messages/Messages.js